import React from 'react';
import { ButtonGroup, IconButton, Button } from 'rsuite';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { DatePeriod } from '@/types/primaryLedgerSnapshots';

interface PeriodNavigatorProps {
  period: DatePeriod;
  onNavigate: (direction: 'previous' | 'next') => void;
  onCurrent: () => void;
}

const PeriodNavigator: React.FC<PeriodNavigatorProps> = ({
  period,
  onNavigate,
  onCurrent
}) => {
  return (
    <ButtonGroup>
      <IconButton
        icon={<ChevronLeft className="h-4 w-4" />}
        onClick={() => onNavigate('previous')}
        aria-label="Previous period"
      />
      <Button onClick={onCurrent}>
        Current
      </Button>
      <IconButton
        icon={<ChevronRight className="h-4 w-4" />}
        onClick={() => onNavigate('next')}
        aria-label="Next period"
      />
    </ButtonGroup>
  );
};

export default PeriodNavigator;